export const DEFAULT_MSA_TRIAL_DAYS = 7;

export function validMsaTrialDays(value: unknown): value is number {
    return typeof value === "number" && Number.isSafeInteger(value) && value > 0 && Number.isFinite(new Date(Date.now() + value * 86400000).getTime());
}

export function msaTrialEndsAt(startedAt: string, days = DEFAULT_MSA_TRIAL_DAYS): string {
    return new Date(new Date(startedAt).getTime() + days * 86400000).toISOString();
}

export function msaCheckoutTrialDays(trialEndsAt: string, now = Date.now()): number {
    const remaining = new Date(trialEndsAt).getTime() - now;
    return remaining > 0 ? Math.max(1, Math.ceil(remaining / 86400000)) : 0;
}
